import { client } from '../client';
import { ApiConfiguration } from './api-configuration';
import { Configuration } from './configuration';
import { asApiConfiguration, asConfiguration } from './mapper';

const get = () =>
  client
    .get<ApiConfiguration>('/timesheets/configuration')
    .then(asConfiguration);

const put = (value: Configuration) =>
  client
    .put<ApiConfiguration, ApiConfiguration>(
      '/timesheets/configuration',
      asApiConfiguration(value),
    )
    .then(asConfiguration);

export const ConfigurationApi = {
  get,
  put,
};
